import type { FlagComponent, GlyphLoader } from './getGlyphComponent'
import * as React from 'react'

type LazyFactory = (loader: GlyphLoader) => React.LazyExoticComponent<FlagComponent>

export function createSafeLazy(lazy: LazyFactory): LazyFactory {
  return function safeLazy(loader: GlyphLoader) {
    return lazy(() =>
      loader().catch((error: unknown) => {
        console.error('IconCountryFlag: failed to load flag chunk', error)

        const NullFlag: FlagComponent = () => null

        return { default: NullFlag }
      }),
    )
  }
}
